import { Controller } from "@hotwired/stimulus"

// Per-element hovercard -- used by _article.html.erb for ActionText inline article references.
// Fetches GET /articles/:id/hovercard, appends the card to <body>, and positions it near the
// triggering element. The card stays visible while the cursor is on either the trigger or the card.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this._showTimer = null
    this._hideTimer = null
    this._card = null
  }

  show() {
    clearTimeout(this._hideTimer)
    this._hideTimer = null
    if (this._showTimer) return
    if (this._card) {
      this._card.style.display = ""
      this._reposition()
      return
    }
    this._showTimer = setTimeout(() => {
      this._showTimer = null
      this._fetch()
    }, 200)
  }

  hide() {
    clearTimeout(this._showTimer)
    this._showTimer = null
    this._hideTimer = setTimeout(() => {
      this._hideTimer = null
      if (this._card) this._card.style.display = "none"
    }, 200)
  }

  _fetch() {
    fetch(this.urlValue)
      .then(r => r.text())
      .then(html => {
        const tmp = document.createElement("div")
        tmp.innerHTML = html
        const card = tmp.firstElementChild
        if (!card) return
        document.body.appendChild(card)
        this._card = card
        this._card.addEventListener("mouseenter", () => {
          clearTimeout(this._hideTimer)
          this._hideTimer = null
        })
        this._card.addEventListener("mouseleave", () => this.hide())
        this._reposition()
      })
  }

  _reposition() {
    if (!this._card) return
    const rect = this.element.getBoundingClientRect()
    const cardW = 384
    const left = Math.max(8, Math.min(rect.left, window.innerWidth - cardW - 8))
    this._card.style.left = `${left}px`
    if (rect.bottom + 260 > window.innerHeight && rect.top > 260) {
      this._card.style.top = "auto"
      this._card.style.bottom = `${window.innerHeight - rect.top + 4}px`
    } else {
      this._card.style.top = `${rect.bottom + 4}px`
      this._card.style.bottom = "auto"
    }
    this._card.style.display = ""
  }

  disconnect() {
    clearTimeout(this._showTimer)
    clearTimeout(this._hideTimer)
    if (this._card) {
      this._card.remove()
      this._card = null
    }
  }
}
